import { z } from 'zod';
export const userRoleSchema = z.enum(['admin', 'hr', 'beoordelaar', 'medewerker']);
export const createUserSchema = z.object({
    email: z.string().email('Ongeldig e-mailadres'),
    name: z.string().min(2, 'Naam moet minimaal 2 karakters zijn'),
    role: userRoleSchema,
    managerId: z.number().optional(),
    password: z.string().min(8, 'Wachtwoord moet minimaal 8 karakters zijn'),
});
export const updateUserSchema = createUserSchema.partial().omit({ password: true });
export const assignRoleSchema = z.object({
    userId: z.number(),
    role: userRoleSchema,
});
export const assignManagerSchema = z.object({
    employeeId: z.number(),
    managerId: z.number(),
});
//# sourceMappingURL=user.js.map